// extracted by mini-css-extract-plugin
export default {"googleMapSection":"GooglemapSection_googleMapSection__vpEL1"};